<template>
  <div class="layout-horizontal">
    <div v-for="col in columns" :key="col.id">
      <div class="layout-horizontal">
        <button @click="moveLeft(col.id)">◀</button>
        <button @click="remove(col.id)">🚫</button>
        <button @click="show(col.id)">?</button>
        <button @click="moveRight(col.id)">▶</button>
      </div>
      <component :is="col.component" :unit="col.id" :itemID="col.id"></component>
    </div>
    <div class="layout-vertical">
      <button @click="addColumn">Dodaj kolumnę</button>
    </div>
  </div>
</template>

<style scoped>
.layout-horizontal {
  display: flex;
  flex-direction: row;
}
</style>

<script>
import ItemList from "../components/ItemList.vue";
import TimeColumn from "../components/TimeList.vue";
import { DATE_UNITS } from "../structure";
import { getItem } from "@/reactive-cache";

export default {
  props: ["itemID"],
  components: {
    ItemList,
    TimeColumn,
  },
  computed: {
    board() {
      return getItem(this.itemID);
    },
    layout() {
      return this.board.layout ?? [];
    },
    columns() {
      return this.layout.map(id => {
        if (DATE_UNITS.includes(id)) {
          return { component: "TimeColumn", id };
        }
        return { component: "ItemList", id };
      });
    },
  },
  methods: {
    addItem(itemType) {
      const rootItem = getItem(`root:${itemType}`);
      const id = Item.createChild(rootItem, itemType);
      if (id) this.appendToLayout(id);
    },
    addColumn() {
      let id = prompt("ID:", "");
      if (id) {
        this.appendToLayout(id);
      }
    },
    show(id) {
      window.prompt("ID:", id)
    },
    appendToLayout(id) {
      if (this.layout.includes(id)) {
        alert("container already present in dashboard");
        return;
      }
      const layout = [...this.layout, id];
      this.board.clone({ layout }).save();
    },
    remove(id) {
      const layout = [...this.layout];
      layout.splice(layout.indexOf(id), 1);
      this.board.clone({ layout }).save();
    },
    moveLeft(id) {
      this.moveColumn(id, "left");
    },
    moveRight(id) {
      this.moveColumn(id, "right");
    },
    moveColumn(id, direction) {
      const layout = [...this.layout];
      const idx = layout.indexOf(id);
      const newIdx = direction === "right" ? idx + 1 : idx - 1;
      if (newIdx >= layout.length || newIdx < 0) {
        return; // already at the end
      }
      layout.splice(idx, 1);
      layout.splice(newIdx, 0, id);
      this.board.clone({ layout }).save();
    },
  },
};
</script>
